import React from 'react';
import './Contact.css';
import { FaPhone, FaEnvelope } from 'react-icons/fa';

const Contact = () => {
  return (
    <div className="contact-page">

      <div className="contact-hero">
        <h1>Get Your Free Estimate</h1>
        <p>No obligation. Just reach out to Aaron and he'll get back to you fast.</p>
      </div>

      <div className="contact-body">

        <div className="contact-cards">

          <a href="tel:+19059796010" className="contact-card contact-card--phone">
            <div className="contact-card-icon">
              <FaPhone />
            </div>
            <div className="contact-card-content">
              <span className="contact-card-label">Call Aaron</span>
              <span className="contact-card-value">905-979-6010</span>
              <span className="contact-card-hint">Tap to call directly</span>
            </div>
          </a>

          <a href="mailto:aaronchiarot7@gmail.com" className="contact-card contact-card--email">
            <div className="contact-card-icon">
              <FaEnvelope />
            </div>
            <div className="contact-card-content">
              <span className="contact-card-label">Email Aaron</span>
              <span className="contact-card-value">aaronchiarot7@gmail.com</span>
              <span className="contact-card-hint">Tap to open your email app</span>
            </div>
          </a>

        </div>

        <div className="contact-info-box">
          <h2>What to Expect</h2>
          <ul>
            <li>📞 Aaron picks up or calls back quickly</li>
            <li>📏 We come out to measure and assess the job at no cost</li>
            <li>📋 You'll receive a clear, honest quote with no hidden fees</li>
            <li>🏆 Best price guaranteed</li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default Contact;
